import type { ReactNode } from "react";
import { Icon } from "./Icon.js";

interface TgHeaderProps {
  title: string;
  onBack?: () => void;
  onClose?: () => void;
  showClose?: boolean;
  /** Кастомный правый слот (например, иконка корзины в shop). Имеет приоритет над showClose. */
  right?: ReactNode;
  /** Дополнительный левый слот рядом с кнопкой «Назад» (например, логотип). */
  left?: ReactNode;
}

export function TgHeader({ title, onBack, onClose, showClose, right, left }: TgHeaderProps) {
  return (
    <div className="tg-header">
      {onBack ? (
        <span className="flex items-center gap-2">
          <button className="tg-btn" onClick={onBack}>
            <Icon name="chevronLeft" size={18} /> Назад
          </button>
          {left}
        </span>
      ) : (
        <span style={{ width: 60 }} />
      )}
      <span className="tg-title">{title}</span>
      {right ? (
        <span className="tg-right">{right}</span>
      ) : showClose ? (
        <button className="tg-btn" onClick={onClose}>
          Закрыть
        </button>
      ) : (
        <span style={{ width: 60 }} />
      )}
    </div>
  );
}
